import { render, staticRenderFns } from "./CustomVideoPlayer.vue?vue&type=template&id=0281c968&scoped=true"
import script from "./CustomVideoPlayer.vue?vue&type=script&lang=js"
export * from "./CustomVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./CustomVideoPlayer.vue?vue&type=style&index=0&id=0281c968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281c968",
  null
  
)

export default component.exports